import React, {Component} from 'react';
import { Layout, Menu } from 'antd';
import { MenuOutlined } from '@ant-design/icons';

import {connect} from 'react-redux';
import {Switch, Route, Link, withRouter} from "react-router-dom";
import AuthenticatedRoute from './AuthenticatedRoute';
import Home from './Home';
import LoginLogoutButtons from './LoginLogoutButtons';
import PremiumCollectionList from './Collections/List/PremiumCollectionList';
import CollectionCreator from './CollectionCreator/CollectionCreator';
import CollectionEditorWrapper from './CollectionEditor/CollectionEditorWrapper';
import CreatorSignup from './CreatorSignup';
import CreatorAboutPage from './CreatorPages/CreatorAboutPage';
import DashboardHome from './Dashboard/Home/DashboardHome';
import CreatedCollectionDetail from './CreatedCollectionDetail';
import ModuleCreator from './ModuleCreator/ModuleCreator';
import PurchasedContent from './Collections/PurchasedContent/PurchasedContent';
import ReportIssuePage from './ReportIssuePage';
import UsedCouponPage from './UsedCoupons/UsedCouponPage';
import QuestionCreator from './QuestionsCreator/QuestionCreator';
import VideoPage from './Collections/Video/VideoPage';
import WalletPage from './Wallet/WalletPage';
import PageNotFound from './PageNotFound';
import { fetchOriginalCollections } from './actions/collection.js';
import { fetchJWTTokens, fetchUserData } from './actions/user.js';
//import Hugo from './Hugo';
import './App.less';
import StudentHome from './Dashboard/Students/StudentHome';
import DashboardPageHeader from './Dashboard/DashboardPageHeader';
import IndividualStudentPage from './Dashboard/Students/IndividualStudentPage';
import VideoHome from './Dashboard/Videos/VideoHome';
import IndividualVideoPage from './Dashboard/Videos/IndividualVideoPage';
import DashboardQnAHome from './Dashboard/QnA/DashboardQnAHome';
import DashboardCollectionQnA from './Dashboard/QnA/DashboardCollectionQnA';
import DashboardModuleQnA from './Dashboard/QnA/DashboardModuleQnA';
import DashboardVideoQnA from './Dashboard/QnA/DashboardVideoQnA';
import AboutUs from './AboutUs';
import DashboardGeneratedReports from './Dashboard/GeneratedReports/DashboardGeneratedReports';
import PremiumCollectionDetail from './Collections/List/PremiumCollectionDetail';
import CreatorHome from './CreatorHome';
import AccountTypeRegistrationModal from './AccountTypeRegistration/AccountTypeRegistrationModal';
import CreatedModuleDetail from './CreatedModuleDetail';
import FAQ from './FAQ';
import AdminHome from './Admin/AdminHome';
import AdminTranscripts from './Admin/AdminTranscripts';
import AdminClassCodes from './Admin/AdminClassCodes';
import AdminClassCodeRoster from './Admin/AdminClassCodeRoster';

const { Header, Content, Footer } = Layout;


class App extends Component {
  componentDidMount() {
    this.props.fetchOriginalCollections()
    if(localStorage.getItem("access") === null){
      this.props.fetchJWTTokens()
    } else if(localStorage.getItem("access") !== null){
      this.props.fetchUserData()
    }
  }
  componentDidUpdate(prevProps) {
    if(prevProps.requireLogin !== this.props.requireLogin && prevProps.requireLogin === true) {
      this.props.fetchUserData()
    }
  }

  render() {
    return (
      <Layout>
        <Header id='header'>
          <div>
            <Link to='/' className='logo' ><img alt="cubits-logo" src={"/cubits-logo.png"}/></Link>
            <div id="header-menus">
              <div className="main-menu-list-container">              
                <Menu theme="dark" mode="horizontal" className="main-menu-list" overflowedIndicator={<MenuOutlined />}>

                  <Menu.Item key="1"><Link to='/collections/'>Premium Collections</Link></Menu.Item>
                  { this.props.isAuthenticated ? <Menu.Item key="2"><Link to='/my-collections/'>My Collections</Link></Menu.Item> : null}
                  { this.props.isAuthenticated ? <Menu.Item key="3"><Link to='/dashboard/'>Dashboard</Link></Menu.Item> : null}
                  
                  <Menu.Item key="4"><Link to='/aboutus/'>About Us</Link></Menu.Item>
                  <Menu.Item key="5"><Link to='/frequently-asked-questions/'>FAQ</Link></Menu.Item>
                </Menu>
              </div>

              <LoginLogoutButtons user={this.props.user || ''} />
            </div>
          </div>
        </Header>
        <Content className="site-layout" style={{marginTop: 64, minHeight: "calc(100vh - 134px)"}}>
          {
            (this.props.isAuthenticated && !this.props.user.completedAccountTypeRegistration) || (this.props.accountTypeRegistrationStatus === "LOADING" || this.props.accountTypeRegistrationStatus === "SUCCESS") ? 
              <AccountTypeRegistrationModal /> 
            :
              <Switch>
              <Route path="/" exact component={Home}/>
                <Route path='/frequently-asked-questions/' component={FAQ} />
                <Route path='/aboutus/' component={AboutUs} />
                <AuthenticatedRoute path='/collections/create/' exact component={CollectionCreator} />
                <AuthenticatedRoute path='/collections/:collectionId/edit/' exact component={CollectionEditorWrapper} />
                <AuthenticatedRoute path='/collections/:collectionId/modules/:moduleIndex/videos/:videoIndex' exact component={VideoPage}/>
                <AuthenticatedRoute path="/collections/:collectionId/modules/:moduleId" exact component={PremiumCollectionDetail} />
                <Route path="/collections/:collectionId" exact component={PremiumCollectionDetail} />
                <Route path='/collections/' exact component={PremiumCollectionList} />
                <AuthenticatedRoute path='/creator/home/' exact component={CreatorHome}/>
                <AuthenticatedRoute path='/creator/created-collections/:collectionId' exact component={CreatedCollectionDetail} />
                <AuthenticatedRoute path='/creator/created-modules/:moduleId' exact component={CreatedModuleDetail} />
                <Route path='/creators/:userId/' exact component={CreatorAboutPage} />
                <AuthenticatedRoute path="/dashboard">
                  <div id="dashboard-home">
                    <DashboardPageHeader/>

                    <Switch>
                      <AuthenticatedRoute path='/dashboard/' exact component={DashboardHome}/>
                      <AuthenticatedRoute path='/dashboard/reports/' exact component={DashboardGeneratedReports} />
                      <AuthenticatedRoute path='/dashboard/qna/' exact component={DashboardQnAHome} />
                      <AuthenticatedRoute path='/dashboard/qna/collections/:collectionId' exact component={DashboardCollectionQnA} />
                      <AuthenticatedRoute path='/dashboard/qna/collections/:collectionId/modules/:moduleId' exact component={DashboardModuleQnA} />
                      <AuthenticatedRoute path='/dashboard/qna/collections/:collectionId/modules/:moduleId/videos/:videoId' exact component={DashboardVideoQnA} />
                      <AuthenticatedRoute path='/dashboard/students/' exact component={StudentHome} />
                      <AuthenticatedRoute path="/dashboard/students/search/:searchTerm" exact component={StudentHome} />
                      <AuthenticatedRoute path='/dashboard/students/:studentID' exact component={IndividualStudentPage} />
                      <AuthenticatedRoute path='/dashboard/videos/' exact component={VideoHome} />
                      <AuthenticatedRoute path="/dashboard/videos/search/:searchTerm" exact component={VideoHome} />
                      <AuthenticatedRoute path="/dashboard/videos/:moduleId/:videoId/" exact component={IndividualVideoPage} />
                    </Switch>
                  </div>
                
                </AuthenticatedRoute>
                
                <AuthenticatedRoute path='/modules/create/' exact component={ModuleCreator} /> 
                {/*<AuthenticatedRoute path='/modules/:moduleId/edit/' exact component={ModuleEditor} />*/}
                <AuthenticatedRoute path='/modules/:moduleId/videos/:videoId/questions/create/' exact component={QuestionCreator} />
                <AuthenticatedRoute path='/my-collections/' exact component={PurchasedContent} />
                <AuthenticatedRoute path='/account' exact component={WalletPage}/>
                <AuthenticatedRoute path='/scheduled-licenses' exact component={UsedCouponPage}/>
                <AuthenticatedRoute path='/report-issue/' exact component={ReportIssuePage} />
                
                <AuthenticatedRoute path='/admin/classcodes/:classCode/roster/' exact component={AdminClassCodeRoster} />
                <AuthenticatedRoute path='/admin/classcodes/' exact component={AdminClassCodes} />
                <AuthenticatedRoute path='/admin/transcripts/' exact component={AdminTranscripts} />
                <AuthenticatedRoute path='/admin/' exact component={AdminHome} />
                <AuthenticatedRoute component={PageNotFound} />
              </Switch>
          }
        </Content>
        <Footer >
          
          <div  style={{ textAlign: 'center' }}>
          support@cuvids.io | CUbits ©2021
          </div>
        </Footer>
      </Layout>
  )}
}

const mapStateToProps = state => {
  return {
    accountTypeRegistrationStatus: state.userReducer.accountTypeRegistrationStatus,
    isAuthenticated: state.userReducer.isAuthenticated,
    user: state.userReducer.user,
    requireLogin: state.userReducer.requireLogin
  }
}
export default connect(mapStateToProps, {fetchOriginalCollections, fetchJWTTokens, fetchUserData})(withRouter(App));
